/**
 * Custom Mega Menu - Dynamic Filter Loader
 * Fetches filters from Storefront API and caches in localStorage
 */

const MegaMenu = {
  // Configuration
  config: {
    storeDomain: window.Shopify?.shop || window.location.hostname,
    storefrontToken: '1ea92805cc002c3e11baec572b52f52f',
    apiVersion: '2025-07',
    collectionHandle: 'blinds',
    cacheKey: 'megaMenuFilters',
    cacheDuration: 60 * 60 * 1000, // 1 hour in ms
  },

  // Icon SVGs mapped by filter type and value
  icons: {
    // Blind types (by taxonomy ID)
    'gid://shopify/TaxonomyValue/8014': `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M4 4h16v2c0 1-1 2-2 2H6c-1 0-2-1-2-2V4z"/><path d="M4 10h16M4 14h16M4 18h16"/><circle cx="19" cy="14" r="2" fill="currentColor"/></svg>`, // Roller
    'gid://shopify/TaxonomyValue/8015': `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="2" width="18" height="4" rx="1" fill="currentColor"/><rect x="3" y="7" width="18" height="4" rx="1"/><rect x="3" y="12" width="18" height="4" rx="1" fill="currentColor"/><rect x="3" y="17" width="18" height="4" rx="1"/></svg>`, // Day & Night
    'gid://shopify/TaxonomyValue/8013': `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M2 4h20M2 8h20M2 12h20M2 16h20M2 20h20"/><path d="M4 2v20M20 2v20" stroke-width="2"/></svg>`, // Venetian
    'gid://shopify/TaxonomyValue/8009': `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M3 3h2v18H3zM7 3h2v18H7zM11 3h2v18h-2zM15 3h2v18h-2zM19 3h2v18h-2z"/><path d="M2 4h20" stroke-width="2"/></svg>`, // Vertical

    // Light control (by taxonomy ID)
    'gid://shopify/TaxonomyValue/20519': `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="4" fill="currentColor"/></svg>`, // Blackout
    'gid://shopify/TaxonomyValue/8003': `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41"/></svg>`, // Light Filtering
    'gid://shopify/TaxonomyValue/8005': `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z"/></svg>`, // Room Darkening

    // Features (by metaobject ID) - pencil-ruler, shield-check, droplet-off, brush
    'gid://shopify/Metaobject/325500666187': `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.375 2.625a1 1 0 0 1 3 3l-9.013 9.014a2 2 0 0 1-.853.505l-2.873.84a.5.5 0 0 1-.62-.62l.84-2.873a2 2 0 0 1 .506-.852z"/></svg>`, // Made To Measure
    'gid://shopify/Metaobject/325500895563': `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"/><path d="m9 12 2 2 4-4"/></svg>`, // Child Safe
    'gid://shopify/Metaobject/325500633419': `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2v4M6.3 6.3l2.8 2.8M2 12h4M6.3 17.7l2.8-2.8M12 18v4M17.7 17.7l-2.8-2.8M22 12h-4M17.7 6.3l-2.8 2.8"/><circle cx="12" cy="12" r="4"/><path d="m15 9-6 6"/></svg>`, // Moisture Resistant
    'gid://shopify/Metaobject/325501387083': `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M9.06 11.9l8.07-8.06a2.85 2.85 0 1 1 4.03 4.03l-8.06 8.08"/><path d="M7.07 14.94c-1.66 0-3 1.35-3 3.02 0 1.33-2.5 1.52-2 2.02 1.08 1.1 2.49 2.02 4 2.02 2.2 0 4-1.8 4-4.04a3.01 3.01 0 0 0-3-3.02z"/></svg>`, // Easy Clean

    // Default/fallback
    default: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M3 9h18M3 15h18"/></svg>`,
  },

  // Feature labels (metaobject handles to nice names)
  featureLabels: {
    'pencil-ruler': 'Made To Measure',
    'shield-check': 'Child Safe',
    'droplet-off': 'Moisture Resistant',
    'brush': 'Easy Clean',
    'sun-moon': 'Day & Night',
    'blinds': 'All Blinds',
    'heart': 'Popular',
  },

  // Colour hex values
  colourHex: {
    'White': '#FFFFFF',
    'Gray': '#808080',
    'Grey': '#808080',
    'Black': '#1a1a1a',
    'Beige': '#F5F5DC',
    'Blue': '#4A6FA5',
    'Navy': '#1a2456',
    'Green': '#5B7553',
    'Brown': '#6B4423',
    'Pink': '#DDA0A0',
    'Red': '#B22222',
    'Orange': '#D2691E',
    'Purple': '#6B4C7A',
    'Bronze': '#CD7F32',
  },

  /**
   * Initialize the mega menu
   */
  init() {
    this.container = document.querySelector('[data-mega-menu-dynamic]');
    if (!this.container) return;

    // Read token from data attribute if available
    const tokenFromAttr = this.container.dataset.storefrontToken;
    if (tokenFromAttr) {
      this.config.storefrontToken = tokenFromAttr;
    }

    this.loadFilters();
  },

  /**
   * Escape HTML to prevent XSS
   */
  escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  },

  /**
   * Convert GID part from filter ID format to proper GID
   * e.g., gid-shopify-taxonomyvalue-8014 → gid://shopify/TaxonomyValue/8014
   */
  convertGidPart(gidPart) {
    return gidPart
      .replace('gid-shopify-', 'gid://shopify/')
      .replace('taxonomyvalue-', 'TaxonomyValue/')
      .replace('metaobject-', 'Metaobject/');
  },

  /**
   * Load filters - from cache or API
   */
  async loadFilters() {
    const cached = this.getCache();

    if (cached) {
      this.render(cached);
      // Refresh cache in background if older than half the cache duration
      if (Date.now() - cached.timestamp > this.config.cacheDuration / 2) {
        this.fetchAndCache();
      }
    } else {
      await this.fetchAndCache();
    }
  },

  /**
   * Get cached data if valid
   */
  getCache() {
    try {
      const cached = localStorage.getItem(this.config.cacheKey);
      if (!cached) return null;

      const data = JSON.parse(cached);
      if (Date.now() - data.timestamp > this.config.cacheDuration) {
        localStorage.removeItem(this.config.cacheKey);
        return null;
      }
      return data;
    } catch (e) {
      return null;
    }
  },

  /**
   * Fetch filters from API and cache
   */
  async fetchAndCache() {
    try {
      const filters = await this.fetchFilters();
      const data = {
        timestamp: Date.now(),
        filters: filters,
      };
      localStorage.setItem(this.config.cacheKey, JSON.stringify(data));
      this.render(data);
    } catch (error) {
      console.error('MegaMenu: Failed to fetch filters', error);
      // Fall back to static content if it exists
    }
  },

  /**
   * Fetch filters from Storefront API
   */
  async fetchFilters() {
    const query = `{
      collection(handle: "${this.config.collectionHandle}") {
        products(first: 1) {
          filters {
            label
            values {
              label
              id
              count
            }
          }
        }
      }
    }`;

    const response = await fetch(
      `https://${this.config.storeDomain}/api/${this.config.apiVersion}/graphql.json`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': this.config.storefrontToken,
        },
        body: JSON.stringify({ query }),
      }
    );

    const json = await response.json();
    return json.data?.collection?.products?.filters || [];
  },

  /**
   * Convert filter ID to URL parameter
   */
  filterIdToUrl(filterId) {
    // Filter IDs come as: filter.v.t.shopify.blind-shade-style.gid-shopify-taxonomyvalue-8014
    // Need to convert to: filter.v.t.shopify.blind-shade-style=gid://shopify/TaxonomyValue/8014
    const parts = filterId.split('.');
    const gidPart = parts.pop();
    const filterPath = parts.join('.');
    const gid = this.convertGidPart(gidPart);

    return `/collections/${this.config.collectionHandle}?${filterPath}=${encodeURIComponent(gid)}`;
  },

  /**
   * Extract GID from filter ID for icon lookup
   */
  extractGid(filterId) {
    const parts = filterId.split('.');
    const gidPart = parts.pop();
    return this.convertGidPart(gidPart);
  },

  /**
   * Get icon SVG for a filter value (returns full SVG with class)
   */
  getIcon(gid) {
    const svg = this.icons[gid] || this.icons.default;
    // Add the icon class to the SVG
    return svg.replace('<svg', '<svg class="custom-mega-menu__icon"');
  },

  /**
   * Render the mega menu
   */
  render(data) {
    const filters = data?.filters || [];

    // If no filters, keep static fallback content
    if (!filters.length) return;

    // Find the filters we need
    const styleFilter = filters.find(f => f.label === 'Style');
    const colourFilter = filters.find(f => f.label === 'Colour');
    const lightControlFilter = filters.find(f => f.label === 'Light control');
    const featuresFilter = filters.find(f => f.label === 'Product Highlights');

    // Build HTML - container already has .custom-mega-menu__columns, just add columns directly
    const html = `
      ${this.renderTypeColumn(styleFilter)}
      ${this.renderLightControlColumn(lightControlFilter, featuresFilter)}
      ${this.renderColourColumn(colourFilter)}
    `;

    this.container.innerHTML = html;
  },

  /**
   * Render Shop by Type column
   */
  renderTypeColumn(filter) {
    const allBlindsIcon = `<svg class="custom-mega-menu__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M3 9h18M3 15h18"/></svg>`;

    let links = `
      <li>
        <a href="/collections/${this.config.collectionHandle}" class="custom-mega-menu__link custom-mega-menu__link--icon">
          ${allBlindsIcon}
          All Blinds
        </a>
      </li>
    `;

    if (filter?.values) {
      links += filter.values.map(value => {
        const gid = this.extractGid(value.id);
        const icon = this.getIcon(gid);
        const url = this.filterIdToUrl(value.id);
        const label = this.escapeHtml(value.label);
        return `
          <li>
            <a href="${url}" class="custom-mega-menu__link custom-mega-menu__link--icon">
              ${icon}
              ${label}
            </a>
          </li>
        `;
      }).join('');
    }

    return `
      <div class="custom-mega-menu__column">
        <span class="custom-mega-menu__heading">Shop by Type</span>
        <ul class="custom-mega-menu__links" role="list">
          ${links}
        </ul>
      </div>
    `;
  },

  /**
   * Render Light Control + Features column
   */
  renderLightControlColumn(lightControl, features) {
    let lightControlLinks = '';
    if (lightControl?.values) {
      lightControlLinks = lightControl.values.map(value => {
        const gid = this.extractGid(value.id);
        const icon = this.getIcon(gid);
        const url = this.filterIdToUrl(value.id);
        const label = this.escapeHtml(value.label);
        return `
          <li>
            <a href="${url}" class="custom-mega-menu__link custom-mega-menu__link--icon">
              ${icon}
              ${label}
            </a>
          </li>
        `;
      }).join('');
    }

    let featuresLinks = '';
    if (features?.values) {
      // Filter to only show the ones we have labels for
      const relevantFeatures = features.values.filter(v =>
        this.featureLabels[v.label] &&
        ['pencil-ruler', 'shield-check', 'droplet-off', 'brush'].includes(v.label)
      );

      featuresLinks = relevantFeatures.map(value => {
        const gid = this.extractGid(value.id);
        const icon = this.getIcon(gid);
        const url = this.filterIdToUrl(value.id);
        const label = this.escapeHtml(this.featureLabels[value.label] || value.label);
        const isHighlight = value.label === 'pencil-ruler';

        return `
          <li>
            <a href="${url}" class="custom-mega-menu__link custom-mega-menu__link--icon${isHighlight ? ' custom-mega-menu__link--highlight' : ''}">
              ${icon}
              ${label}
            </a>
          </li>
        `;
      }).join('');
    }

    return `
      <div class="custom-mega-menu__column">
        <span class="custom-mega-menu__heading">Light Control</span>
        <ul class="custom-mega-menu__links" role="list">
          ${lightControlLinks}
        </ul>
        ${featuresLinks ? `
          <span class="custom-mega-menu__heading custom-mega-menu__heading--sub">Features</span>
          <ul class="custom-mega-menu__links" role="list">
            ${featuresLinks}
          </ul>
        ` : ''}
      </div>
    `;
  },

  /**
   * Render Colour swatches column
   */
  renderColourColumn(filter) {
    let swatches = '';
    if (filter?.values) {
      swatches = filter.values.map(value => {
        const url = this.filterIdToUrl(value.id);
        const hex = this.colourHex[value.label] || '#888888';
        const isWhite = value.label === 'White';
        const label = this.escapeHtml(value.label);

        return `
          <li>
            <a href="${url}" class="custom-mega-menu__swatch" title="${label}">
              <span class="custom-mega-menu__swatch-color${isWhite ? ' custom-mega-menu__swatch-color--white' : ''}" style="background-color: ${hex};"></span>
              <span class="custom-mega-menu__swatch-label">${label}</span>
            </a>
          </li>
        `;
      }).join('');
    }

    return `
      <div class="custom-mega-menu__column">
        <span class="custom-mega-menu__heading">Shop by Colour</span>
        <ul class="custom-mega-menu__swatches" role="list">
          ${swatches}
        </ul>
      </div>
    `;
  },
};

function initMegaMenuHover() {
  let closeTimeout = null;

  document.querySelectorAll('.custom-mega-menu__item').forEach((item) => {
    const trigger = item.querySelector('.custom-mega-menu__trigger');
    const dropdown = item.querySelector('.custom-mega-menu__dropdown');
    if (!trigger || !dropdown) return;

    function open() {
      clearTimeout(closeTimeout);
      document.querySelectorAll('.custom-mega-menu__item.is-open').forEach((el) => el.classList.remove('is-open'));
      item.classList.add('is-open');
    }

    function scheduleClose() {
      closeTimeout = setTimeout(() => item.classList.remove('is-open'), 200);
    }

    trigger.addEventListener('mouseenter', open);
    trigger.addEventListener('mouseleave', scheduleClose);
    dropdown.addEventListener('mouseenter', () => clearTimeout(closeTimeout));
    dropdown.addEventListener('mouseleave', scheduleClose);
  });
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => { MegaMenu.init(); initMegaMenuHover(); });
} else {
  MegaMenu.init();
  initMegaMenuHover();
}
